var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comments"},[_c('ul',[_vm._l((_vm.commentList),function(comment,index){return [(comment)?_c('li',{key:`comment_${index}`},[_vm._v(_vm._s(comment))]):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }